import { render, staticRenderFns } from "./Symptoms.vue?vue&type=template&id=3990140a"
import script from "./Symptoms.vue?vue&type=script&lang=js"
export * from "./Symptoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports